import React, { Ref } from 'react';
import SpareComponentAppearanceOnError from './SpareComponentAppearanceOnError';

export interface IError {
  message: string;
  stack?: string;
  name?: string;
}

interface IWrappedComponentProps {
  forwardRef: Ref<HTMLElement>;
}
interface IState {
  componentHasError: boolean;
  error: IError | null;
}

function withErrorBoundary<P>(Component: React.ComponentType<P>) {
  class ComponentWithErrorBoundary<T> extends React.Component<T & IWrappedComponentProps> {
    state: IState = {
      componentHasError: false,
      error: null,
    };

    static getDerivedStateFromError(error: IError) {
      return {
        componentHasError: true,
        error,
      };
    }

    render() {
      const { forwardRef, ...rest } = this.props;
      const { componentHasError, error } = this.state;

      /* "window.pageWithErrorEnabled"
      -- Solution for testing error layout,
         can be removed after testing.

         Can be added via developer console. Resets after page reload.
      */

      if (componentHasError || window.pageWithErrorEnabled) {
        return <SpareComponentAppearanceOnError error={error} />;
      }

      return <Component {...(rest as unknown as P)} ref={forwardRef} />;
    }
  }

  return React.forwardRef((props: P, ref) => (
    <ComponentWithErrorBoundary {...props} forwardRef={ref as IWrappedComponentProps['forwardRef']} />
  ));
}

export default withErrorBoundary;
